import { ErrorReference } from '../../types';

export const CHECK_REPORT_WEBHOOK_DATA_UNAVAILABLE: ErrorReference = {
  server: {
    error_type: 'CHECK_REPORT_ERROR',
    error_code: 'DATA_UNAVAILABLE',
    error_message:
      'the check report did not have sufficient data to generate a report. Review the repairable_items list for any Items the user can fix via Link update mode. Once completed, a new report can be generated by calling /cra/check_report/create',
    display_message: null,
    http_code: 400,
  },
  link: null,
};

export const CHECK_REPORT_WEBHOOK_PRODUCT_GENERATION_FAILED: ErrorReference = {
  server: {
    error_type: 'CHECK_REPORT_ERROR',
    error_code: 'PRODUCT_GENERATION_FAILED',
    error_message:
      'all requested products failed to generate. Call the corresponding product /get endpoint for product-specific error details',
    display_message: null,
    http_code: 400,
  },
  link: null,
};

export const CHECK_REPORT_WEBHOOK_INTERNAL_SERVER_ERROR: ErrorReference = {
  server: {
    error_type: 'CHECK_REPORT_ERROR',
    error_code: 'INTERNAL_SERVER_ERROR',
    error_message:
      'an internal error occurred while generating the report. Please retry by calling /cra/check_report/create',
    display_message: null,
    http_code: 500,
  },
  link: null,
};
